module.exports = __webpack_public_path__ + "static/media/barcode-alt.8983e6c1.svg";